export enum DbMarkerCategory {
  Human = "Human",
  BatonAutoQc = "BatonAutoQc",
  HybrikAutoQc = "HybrikAutoQc",
  ThumbRef = "ThumbRef",
  ThumbPgm = "ThumbPgm",
  SceneChange = "SceneChange",
  DubCardImageExtraction = "DubCardImageExtraction",
}
